import React from 'react';

type SectionProps = {
    className?: string;
    children: any;
    spacing?: 'narrow' | 'regular' | 'wide' | 'onlyPadding' | 'paddingAndMargin' | 'none';
    background?: boolean;
    customSpacing?: string;
    customBackground?: string;
};

export const Section = ({ children, spacing = 'regular', background = false, className, customSpacing, customBackground }: SectionProps) => {
    const getSpacing = () => {
        if (customSpacing) {
            return customSpacing;
        }
        switch (spacing) {
            case 'onlyPadding':
                return 'lg:tw-py-[100px] tw-py-48';
            case 'paddingAndMargin':
                return 'lg:tw-py-[100px] tw-py-48 lg:tw-mt-[120px] tw-mt-48';
            case 'narrow':
                return 'lg:tw-mt-64 tw-mt-48';
            case 'regular':
                return 'lg:tw-mt-[120px] tw-mt-48';
            case 'wide':
                return 'lg:tw-mt-[120px] tw-mt-48';
            case 'none':
                return '';
            default:
                return '';
        }
    };

    return (
        <section className={`${getSpacing()} ${background && !customBackground ? 'tw-bg-neutral-body' : ''} ${className}`} style={{
            backgroundColor: customBackground ? customBackground : ''
        }}>
            {children}
        </section>
    );
};
